import Box from '@/components/UI/box/Box';
import styles from './UnitCountInfo.module.scss';
import Typography from '@/components/UI/typography/Typography';
import Icon from '@/components/UI/icon/Icon';
const UnitCountInfo = () => {
  return <>
      <Box className={styles['unit-count-type']} data-sentry-element="Box" data-sentry-source-file="UnitCountInfo.tsx">
        <Icon name="info-circle" type={'mediumEmphasis'} data-sentry-element="Icon" data-sentry-source-file="UnitCountInfo.tsx"></Icon>
        <Typography className={styles['unit-count-text']} variant="bodyS" data-sentry-element="Typography" data-sentry-source-file="UnitCountInfo.tsx">
          این اقامتگاه دارای چند واحد با امکانات و شرایط یکسان است که تنها در
          دکور یا طبقه تفاوت دارند. پس از رزرو، بسته به موجودی اقامتگاه یکی از
          این واحدها در اختیار مهمان قرار خواهد گرفت.
        </Typography>
      </Box>
    </>;
};
export default UnitCountInfo;